import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private requestCount = 0;
  private slowRequestThreshold = 5000; // ms
  private showSpinnerDelay = 300;      // ms

  private spinnerTimeout: any;

  constructor(private ngxSpinner: NgxSpinnerService) {}

  requestStarted(): void {
    this.requestCount++;

    if (this.requestCount === 1) {
      // Espera antes de mostrar para evitar parpadeos
      this.spinnerTimeout = setTimeout(() => {
        this.ngxSpinner.show();
      }, this.showSpinnerDelay);
    }
  }

  requestEnded(): void {
    if (this.requestCount > 0) this.requestCount--;

    if (this.requestCount === 0) {
      clearTimeout(this.spinnerTimeout);
      this.ngxSpinner.hide();
    }
  }

  resetSpinner(): void {
    this.requestCount = 0;
    clearTimeout(this.spinnerTimeout);
    this.ngxSpinner.hide();
  }
}
